import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function BayCityPage() {
  const location = getLocationById('bay-city');
  if (!location) {
    return <div data-id="element-769">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-770">
      <Header data-id="element-771" />

      <main className="pt-20" data-id="element-772">
        <LocationPageHero location={location} data-id="element-773" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-774" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-775" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-776" />
      </main>

      <Footer data-id="element-777" />
    </div>;
}